/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { QuoteRestriction } from './QuoteRestriction';
import {
    QuoteRestrictionFromJSON,
    QuoteRestrictionFromJSONTyped,
    QuoteRestrictionToJSON,
    QuoteRestrictionToJSONTyped,
} from './QuoteRestriction';
import type { EquipmentType } from './EquipmentType';
import {
    EquipmentTypeFromJSON,
    EquipmentTypeFromJSONTyped,
    EquipmentTypeToJSON,
    EquipmentTypeToJSONTyped,
} from './EquipmentType';

/**
 * Represents a response from a carrier to a particular quote
 * @export
 * @interface Quote
 */
export interface Quote {
    /**
     * 
     * @type {Date}
     * @memberof Quote
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    quoteId: string;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    price: number;
    /**
     * 
     * @type {Currency}
     * @memberof Quote
     */
    currency: Currency;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    carrierLogoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    carrierDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    carrierIdentifier: string;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    transitBusinessDays?: number;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    serviceDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    quotedPickupDate: string;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    taxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    latestTransitBusinessDays?: number;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    latestEstimatedDeliveryDate?: string;
    /**
     * 
     * @type {EquipmentType}
     * @memberof Quote
     */
    equipmentType?: EquipmentType;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    transitBusinessDaysDescription?: string;
    /**
     * 
     * @type {Array<QuoteRestriction>}
     * @memberof Quote
     */
    restrictions?: Array<QuoteRestriction>;
    /**
     * True when this quote came from a customer-specific pricing agreement that FreightSimple negotiated on the company's behalf.
     * @type {boolean}
     * @memberof Quote
     */
    isCustomerSpecificPricing?: boolean;
}



/**
 * Check if a given object implements the Quote interface.
 */
export function instanceOfQuote(value: object): value is Quote {
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('carrierLogoUrl' in value) || value['carrierLogoUrl'] === undefined) return false;
    if (!('carrierDisplayName' in value) || value['carrierDisplayName'] === undefined) return false;
    if (!('carrierIdentifier' in value) || value['carrierIdentifier'] === undefined) return false;
    if (!('serviceDisplayName' in value) || value['serviceDisplayName'] === undefined) return false;
    if (!('quotedPickupDate' in value) || value['quotedPickupDate'] === undefined) return false;
    if (!('taxAmount' in value) || value['taxAmount'] === undefined) return false;
    return true;
}

export function QuoteFromJSON(json: any): Quote {
    return QuoteFromJSONTyped(json, false);
}

export function QuoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Quote {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'quoteId': json['quoteId'],
        'price': json['price'],
        'currency': CurrencyFromJSON(json['currency']),
        'carrierLogoUrl': json['carrierLogoUrl'],
        'carrierDisplayName': json['carrierDisplayName'],
        'carrierIdentifier': json['carrierIdentifier'],
        'transitBusinessDays': json['transitBusinessDays'] == null ? undefined : json['transitBusinessDays'],
        'serviceDisplayName': json['serviceDisplayName'],
        'expectedDeliveryDate': json['expectedDeliveryDate'] == null ? undefined : json['expectedDeliveryDate'],
        'quotedPickupDate': json['quotedPickupDate'],
        'taxAmount': json['taxAmount'],
        'latestTransitBusinessDays': json['latestTransitBusinessDays'] == null ? undefined : json['latestTransitBusinessDays'],
        'latestEstimatedDeliveryDate': json['latestEstimatedDeliveryDate'] == null ? undefined : json['latestEstimatedDeliveryDate'],
        'equipmentType': json['equipmentType'] == null ? undefined : EquipmentTypeFromJSON(json['equipmentType']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'transitBusinessDaysDescription': json['transitBusinessDaysDescription'] == null ? undefined : json['transitBusinessDaysDescription'],
        'restrictions': json['restrictions'] == null ? undefined : ((json['restrictions'] as Array<any>).map(QuoteRestrictionFromJSON)),
        'isCustomerSpecificPricing': json['isCustomerSpecificPricing'] == null ? undefined : json['isCustomerSpecificPricing'],
    };
}

  export function QuoteToJSON(json: any): Quote {
      return QuoteToJSONTyped(json, false);
  }

  export function QuoteToJSONTyped(value?: Quote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'quoteId': value['quoteId'],
        'price': value['price'],
        'currency': CurrencyToJSON(value['currency']),
        'carrierLogoUrl': value['carrierLogoUrl'],
        'carrierDisplayName': value['carrierDisplayName'],
        'carrierIdentifier': value['carrierIdentifier'],
        'transitBusinessDays': value['transitBusinessDays'],
        'serviceDisplayName': value['serviceDisplayName'],
        'expectedDeliveryDate': value['expectedDeliveryDate'],
        'quotedPickupDate': value['quotedPickupDate'],
        'taxAmount': value['taxAmount'],
        'latestTransitBusinessDays': value['latestTransitBusinessDays'],
        'latestEstimatedDeliveryDate': value['latestEstimatedDeliveryDate'],
        'equipmentType': EquipmentTypeToJSON(value['equipmentType']),
        'notes': value['notes'],
        'transitBusinessDaysDescription': value['transitBusinessDaysDescription'],
        'restrictions': value['restrictions'] == null ? undefined : ((value['restrictions'] as Array<any>).map(QuoteRestrictionToJSON)),
        'isCustomerSpecificPricing': value['isCustomerSpecificPricing'],
    };
}

